import { useCallback } from "react";
import { useCachedQuery } from "./useCachedQuery";
import { fetchEmbeddingUsageHistory, type TenantUsageHistory } from "./useAdminStatus";
import { rangeToWindowHours, type InstanceRange } from "../lib/instanceDetailRange";
import type { InstanceUsageResult } from "./useInstanceUsage";

// Deliberately uncached, unlike useInstanceUsage. Embedding spend moves in
// fractions of a cent and is read far less often, so a stale seed would buy
// nothing and a localStorage entry per tenant would cost more than it saves.
export const useInstanceEmbeddingUsage = (
  tenantId: string,
  range: InstanceRange,
): InstanceUsageResult => {
  const hours = rangeToWindowHours(range);
  const fetcher = useCallback(
    (signal: AbortSignal): Promise<TenantUsageHistory> =>
      fetchEmbeddingUsageHistory(tenantId, hours, signal),
    [tenantId, hours],
  );
  const { status, data, error, isFetching } = useCachedQuery<TenantUsageHistory>({
    cacheResource: null,
    queryKey: `/api/admin/claws/${tenantId}/embedding-usage-history?hours=${hours}`,
    fetcher,
  });
  return { status, usage: data, error, isFetching };
};
